import {
  // DOMAINS
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAIL,
  GET_CREDENTIALS_SUCCESS,
  GET_CREDENTIALS_FAIL,
  ADD_DOMAIN_SUCCESS,
  ADD_DOMAIN_FAIL,
  UPDATE_DOMAIN_SUCCESS,
  UPDATE_DOMAIN_FAIL,
  DELETE_DOMAIN_SUCCESS,
  DELETE_DOMAIN_FAIL,
  // SUBSCRIPTIONS
  GET_SUBS_SUCCESS,
  GET_SUBS_FAIL,
  ADD_SUB_SUCCESS,
  ADD_SUB_FAIL,
  UPDATE_SUB_SUCCESS,
  UPDATE_SUB_FAIL,
  DELETE_SUB_SUCCESS,
  DELETE_SUB_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  error: "",
  domains: [],
  domain_info: [],
  subs: [],
  showPwd: true,
  hidePwd: false,
  loading: false,
}

const domains = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DOMAINS_SUCCESS:
      return {
        ...state,
        domains: action.payload,
      };
    case GET_DOMAINS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_CREDENTIALS_SUCCESS:
      return {
        ...state,
        domain_info: action.payload,
        // domains: [...state.domains, action.payload],
        success: { data: "success" },
        error: ""
      };
    case GET_CREDENTIALS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_DOMAIN_SUCCESS:
      return {
        ...state,
        domains: [...state.domains, action.payload],
        success: { data: "success" },
      };
    case ADD_DOMAIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_DOMAIN_SUCCESS:
      return {
        ...state,
        domains: state.domains.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      };
    case UPDATE_DOMAIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_DOMAIN_SUCCESS:
      return {
        ...state,
        domains: state.domains.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      };
    case DELETE_DOMAIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_SUBS_SUCCESS:
      return {
        ...state,
        subs: action.payload,
      };
    case GET_SUBS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_SUB_SUCCESS:
      return {
        ...state,
        subs: [...state.subs, action.payload],
        success: { data: "success" },
      };
    case ADD_SUB_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SUB_SUCCESS:
      return {
        ...state,
        subs: state.subs.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      };
    case UPDATE_SUB_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_SUB_SUCCESS:
      return {
        ...state,
        subs: state.subs.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      };
    case DELETE_SUB_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state
  }
}

export default domains
